// extracted by mini-css-extract-plugin
module.exports = {"container":"hrProcessCandidateCard_container__3Zjt3"};